import(/* webpackMode: "eager" */ "/home/runner/work/kst-frontend/kst-frontend/app/own-and-earn/calculator/page.tsx")